module.exports = __webpack_public_path__ + "static/media/facebook-white.4bd348f6.svg";